import React from 'react';
import PropTypes from "prop-types";

function Marker({ lat, lng, onClick, count, selected}) {

    const SIZE_NORMAL = 47;
    const SIZE_HOVER_SELECTED = 52;

    const COLOR_NORMAL = '#A49271';
    const COLOR_SELECTED = '#000';
    const TEXT_COLOR = '#000';
    const TEXT_COLOR_SELECTED = '#fff';

    const size = (selected) ? SIZE_HOVER_SELECTED : SIZE_NORMAL;
    const color = (selected) ? COLOR_SELECTED : COLOR_NORMAL;
    const textColor = (selected) ? TEXT_COLOR_SELECTED : TEXT_COLOR;

    const clusterStyle = {
        position: 'absolute',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transform: 'translate(-50%, -50%)',
    };

    return (
        <div style={clusterStyle} onClick={onClick}>
            <svg viewBox="0 0 47 47" width={size} height={size} fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.2" cx="23.5017" cy="23.2624" r="22.8054" fill={color}/>
                <circle opacity="0.4" cx="23.5016" cy="23.2624" r="19.0045" fill={color}/>
                <circle opacity="0.6" cx="23.5015" cy="23.2624" r="15.2036" fill={color}/>
                <circle cx="23.5013" cy="23.2624" r="11.4027" fill={color}/>
                <text x="50%" y="50%" textAnchor="middle" alignmentBaseline="middle" fill={textColor} fontSize="11">
                    {count}
                </text>
            </svg>
        </div>
    );
}

Marker.propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    count: PropTypes.number,
    onClick: PropTypes.func,
};

export default Marker;



// WEBPACK FOOTER //
// ./src/components/Map/Planner/Marker.js